import { Selection } from "../../contracts";

export const filterOutrightSelections = (selections: Selection[]) => {
    let activeSelection = selections.filter((s: Selection) => !s.isDisabled);
    return activeSelection.filter((s: Selection) => s.tags && s.tags.indexOf("Place") < 0);
}